// import React from "react";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import FadeInOnScroll from "./FadeInOnScroll";
// import { motion } from "framer-motion";

// export default function OurSolutions() {
//   // 圆形图：缩放 + 轻微旋转
//   const circleVariants = {
//     hidden: { opacity: 0, scale: 0.9, rotate: -4 },
//     visible: {
//       opacity: 1,
//       scale: 1,
//       rotate: 0,
//       transition: { duration: 0.45, ease: "easeOut" },
//     },
//   };

//   // 右侧文字：从右侧滑入
//   const textVariants = {
//     hidden: { opacity: 0, x: 24 },
//     visible: {
//       opacity: 1,
//       x: 0,
//       transition: { duration: 0.4, ease: "easeOut" },
//     },
//   };

//   // 底部三卡片容器
//   const cardsContainer = {
//     hidden: {},
//     visible: {
//       transition: {
//         staggerChildren: 0.14,
//       },
//     },
//   };

//   // 单个卡片
//   const cardItem = {
//     hidden: { opacity: 0, y: 20 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: { duration: 0.4, ease: "easeOut" },
//     },
//   };

//   return (
//     <>
//       <section className="relative overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] py-24 px-6">
//         <div className="max-w-7xl mx-auto">
//           {/* ===== 顶部 Title ===== */}
//           <div className="text-center mb-16">
//             <FadeInOnScroll>
//               <h2 className="text-4xl md:text-5xl font-extrabold mb-4 bg-gradient-to-r from-[#6a2dd9] to-[#9a8dfc] bg-clip-text text-transparent">
//                 DESIGNING YOUR FUTURE
//               </h2>
//               <p className="text-sm tracking-wider text-[#5e4ca8] font-semibold mb-28">
//                 OUR CUSTOM SOLUTIONS
//               </p>
//             </FadeInOnScroll>
//           </div>

//           {/* ===== 中间：左图右文 ===== */}
//           <motion.div
//             className="grid md:grid-cols-2 gap-12 items-center mb-16 max-w-6xl mx-auto"
//             initial={{ opacity: 0, y: 15 }}
//             animate={{ opacity: 1, y: 0 }} // ✅ 不再依赖滚动，进入页面就淡入
//             transition={{ duration: 0.35, ease: "easeOut" }}
//           >
//             {/* 左侧：圆形图（缩放+轻微旋转入场） */}
//             <motion.div
//               className="flex justify-center"
//               variants={circleVariants}
//               initial="hidden"
//               animate="visible" // ✅ 改用 animate
//             >
//               <div className="relative w-[320px] h-[320px] md:w-[380px] md:h-[380px]">
//                 {/* 外圈虚线圆 */}
//                 <div className="absolute inset-[-32px] md:inset-[-38px] rounded-full border-4 border-dashed border-[#d8c9ff] opacity-60 pointer-events-none animate-spin-slow" />

//                 {/* AI Consulting */}
//                 <div className="absolute top-[26px] left-[0px] w-[160px] h-[160px] md:w-[190px] md:h-[190px] bg-[#f06273] rounded-full opacity-90 flex items-center justify-center text-white font-bold text-center shadow-[0_0_25px_rgba(138,79,255,0.25)]">
//                   AI
//                   <br />
//                   CONSULTING
//                 </div>

//                 {/* IDC Consulting */}
//                 <div className="absolute top-[26px] right-[0px] w-[160px] h-[160px] md:w-[190px] md:h-[190px] bg-[#9a6bff] rounded-full opacity-90 flex items-center justify-center text-white font-bold text-center shadow-[0_0_25px_rgba(138,79,255,0.25)]">
//                   IDC
//                   <br />
//                   CONSULTING
//                 </div>

//                 {/* Managed Services */}
//                 <div className="absolute bottom-[-10px] md:bottom-[-20px] left-1/2 -translate-x-1/2 w-[170px] h-[170px] md:w-[200px] md:h-[200px] bg-[#6a2dd9] rounded-full opacity-90 flex items-center justify-center text-white font-bold text-center shadow-[0_0_25px_rgba(138,79,255,0.25)]">
//                   MANAGED
//                   <br />
//                   SERVICES
//                 </div>

//                 {/* 中心：Custom Solutions */}
//                 <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white/95 rounded-full w-[95px] h-[95px] md:w-[110px] md:h-[110px] flex items-center justify-center text-[#1e0b44] font-bold text-xs md:text-sm shadow-[0_0_25px_rgba(138,79,255,0.25)]">
//                   CUSTOM
//                   <br />
//                   SOLUTIONS
//                 </div>
//               </div>
//             </motion.div>

//             {/* 右侧：文案描述（从右滑入） */}
//             <motion.div
//               className="space-y-4 text-lg font-semibold text-purple-900 tracking-wide text-center max-w-xl mx-auto"
//               variants={textVariants}
//               initial="hidden"
//               animate="visible" // ✅ 改用 animate
//             >
//               <p>
//                 At the heart of our innovation lies the AI Nova Ecosystem.
//                 <br /> An integrated framework that combines high-performance
//                 <br />
//                 compute infrastructure, data and MLOps frameworks, and
//                 <br />
//                 platform enablement for real-world applications.
//               </p>
//               <p>
//                 Through our strategic collaboration with global OTT
//                 <br />
//                 partners, AI Nova is bringing AI capabilities directly to
//                 <br />
//                 where people live, connect and build their communities.
//               </p>
//               <p>
//                 AI NOVA turns infrastructure into actionable intelligence,
//                 <br />
//                 helping integrate AI into everyday operations.
//               </p>
//             </motion.div>
//           </motion.div>

//           {/* ===== 底部：三个卡片（竖排） ===== */}
//           <motion.div
//             className="space-y-6 max-w-3xl mx-auto mt-28"
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true, amount: 0.2 }} // 稍微安全一点
//             variants={cardsContainer}
//           >
//             {/* AI Consulting */}
//             <motion.div
//               className="bg-[#fce8ee] rounded-xl p-6 shadow-[0_4px_20px_rgba(138,79,255,0.1)]"
//               variants={cardItem}
//             >
//               <h3 className="text-xl font-bold text-[#8a2f4f] mb-2">
//                 AI CONSULTING
//               </h3>
//               <p className="text-purple-900 tracking-wide text-[0.95rem] leading-relaxed text-justify">
//                 Our team of AI experts brings industry-leading expertise in
//                 machine learning, deep learning, and advanced analytics
//                 customised to real-world scenarios.
//                 <br />
//                 <br />
//                 We collaborate closely with clients through the design,
//                 development, and deployment of practical AI solutions tailored
//                 to their specific industry needs — enabling measurable business
//                 outcomes.
//               </p>
//             </motion.div>

//             {/* IDC Consulting */}
//             <motion.div
//               className="bg-[#f4e8ff] rounded-xl p-6 shadow-[0_4px_20px_rgba(138,79,255,0.1)]"
//               variants={cardItem}
//             >
//               <h3 className="text-xl font-bold text-[#6a2dd9] mb-2">
//                 IDC CONSULTING
//               </h3>
//               <ul className="list-disc pl-5 text-purple-900 tracking-wide text-[0.95rem] space-y-1 leading-relaxed">
//                 <li>
//                   Expert E2E guidance across all facets of DC architectures.
//                 </li>
//                 <li>
//                   Server configuration optimized for specific workload profiles.
//                 </li>
//                 <li>
//                   Network topology design for high availability and low latency.
//                 </li>
//                 <li>
//                   Security consulting focusing on physical and logical
//                   protection.
//                 </li>
//               </ul>
//             </motion.div>

//             {/* Managed Services */}
//             <motion.div
//               className="bg-[#ece6ff] rounded-xl p-6 shadow-[0_4px_20px_rgba(138,79,255,0.1)]"
//               variants={cardItem}
//             >
//               <h3 className="text-xl font-bold text-[#3a1f7a] mb-2">
//                 MANAGED SERVICES
//               </h3>
//               <ul className="list-disc pl-5 text-purple-900 tracking-wide text-[0.95rem] space-y-1 leading-relaxed">
//                 <li>
//                   24/7 proactive monitoring, predictive maintenance, and fault
//                   detection.
//                 </li>
//                 <li>SLA-backed uptime and rapid response support.</li>
//                 <li>
//                   Expert troubleshooting ensuring sustained performance and
//                   reliability.
//                 </li>
//                 <li>
//                   Transparent communication ensuring trust and accountability
//                   through the service lifecycle.
//                 </li>
//               </ul>
//             </motion.div>
//           </motion.div>
//         </div>
//       </section>

//       <style>
//         {`
//           @keyframes spinSlow {
//             from { transform: rotate(0deg); }
//             to { transform: rotate(360deg); }
//           }
//           .animate-spin-slow {
//             animation: spinSlow 18s linear infinite;
//           }
//         `}
//       </style>
//     </>
//   );
// }
import React, { useState } from "react";
import FadeInOnScroll from "./FadeInOnScroll";
import { motion } from "framer-motion";

export default function OurSolutions() {
  const [activeKey, setActiveKey] = useState(null); // "ai" | "idc" | "managed" | null

  // 圆形图：缩放 + 轻微旋转
  const circleVariants = {
    hidden: { opacity: 0, scale: 0.9, rotate: -4 },
    visible: {
      opacity: 1,
      scale: 1,
      rotate: 0,
      transition: { duration: 0.45, ease: "easeOut" },
    },
  };

  // 右侧容器：从右侧滑入
  const textVariants = {
    hidden: { opacity: 0, x: 24 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  // stagger 仍保留（只做 opacity 入场，避免和 hover 的 y 冲突）
  const cardsContainer = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.14 },
    },
  };

  // 卡片入场：只控制 opacity（✅ hover 的 y/scale 交给 animate/whileHover）
  const cardItem = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.35, ease: "easeOut" } },
  };

  const outerText =
    "text-white font-extrabold text-[13px] md:text-[15px] leading-[1.15] tracking-[0.12em] text-center";

  const centerText =
    "text-[#1e0b44] font-extrabold text-[12px] md:text-[14px] leading-[1.1] tracking-[0.10em] text-center";

  // ✅ 左边圆 hover：只上移 + 更强 shadow，不要白色 border（不加 ring）
  const circleBase =
    "rounded-full flex items-center justify-center shadow-[0_18px_40px_rgba(30,11,68,0.12)] transform transition-all duration-200 ease-out will-change-transform";
  const circleHover =
    "-translate-y-2 shadow-[0_30px_70px_rgba(30,11,68,0.22)] z-20";

  // ✅ 右侧卡片 hover 视觉增强（明显一点）
  const cardBase =
    "rounded-xl p-6 shadow-[0_4px_20px_rgba(138,79,255,0.1)] transition-shadow duration-200 ease-out";
  const cardActiveVisual = "shadow-[0_18px_45px_rgba(138,79,255,0.25)]";

  // ✅ 右侧卡片：联动上浮参数（也用于 hover）
  const lift = { y: -12, scale: 1.02 };
  const rest = { y: 0, scale: 1 };

  return (
    <>
      <section className="relative overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] py-24 px-6">
        <div className="max-w-7xl mx-auto">
          {/* ===== 顶部 Title ===== */}
          <div className="text-center mb-16">
            <FadeInOnScroll>
              <h2 className="text-4xl md:text-5xl font-extrabold mb-4 text-[#252666]">
                DESIGNING YOUR FUTURE
              </h2>
              <p className="text-sm tracking-wider text-[#5e4ca8] font-semibold mb-8">
                OUR CUSTOM SOLUTIONS
              </p>
              <div className="space-y-4 text-lg font-semibold text-[#6b5fa9] tracking-wide text-center max-w-5xl mx-auto">
                <p>
                  At the heart of our innovation lies the AI Nova Ecosystem. An
                  integrated framework that combines high-performance compute
                  infrastructure, data and MLOps frameworks, and platform
                  enablement for real-world applications.
                </p>
                <p>
                  Through our strategic collaboration with global OTT partners,
                  AI Nova is bringing AI capabilities <br /> directly to where
                  people live, connect and build their communities.
                </p>
                <p>
                  AI NOVA turns infrastructure into actionable intelligence,
                  helping integrate AI into everyday operations.
                </p>
              </div>
            </FadeInOnScroll>
          </div>

          {/* ===== 中间：左图 + 右侧三张彩色卡片 ===== */}
          <motion.div
            className="grid md:grid-cols-2 gap-12 items-center mb-16 max-w-6xl mx-auto"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
          >
            {/* 左侧：圆形图 */}
            <motion.div
              className="flex justify-center"
              variants={circleVariants}
              initial="hidden"
              animate="visible"
            >
              <div className="relative w-[320px] h-[320px] md:w-[380px] md:h-[380px]">
                {/* 外圈虚线圆 */}
                <div className="absolute inset-[-32px] md:inset-[-38px] rounded-full border-4 border-dashed border-[#d8c9ff] opacity-60 pointer-events-none animate-spin-slow" />

                {/* AI Consulting */}
                <div
                  onMouseEnter={() => setActiveKey("ai")}
                  onMouseLeave={() => setActiveKey(null)}
                  className={[
                    "absolute top-[26px] left-[0px] w-[160px] h-[160px] md:w-[190px] md:h-[190px] bg-[#6C3ECB]",
                    circleBase,
                    activeKey === "ai" ? circleHover : "",
                    "cursor-pointer",
                  ].join(" ")}
                >
                  <div className={outerText}>
                    AI
                    <br />
                    CONSULTING
                  </div>
                </div>

                {/* IDC Consulting */}
                <div
                  onMouseEnter={() => setActiveKey("idc")}
                  onMouseLeave={() => setActiveKey(null)}
                  className={[
                    "absolute top-[26px] right-[0px] w-[160px] h-[160px] md:w-[190px] md:h-[190px] bg-[#C63D96]",
                    circleBase,
                    activeKey === "idc" ? circleHover : "",
                    "cursor-pointer",
                  ].join(" ")}
                >
                  <div className={outerText}>
                    IDC
                    <br />
                    CONSULTING
                  </div>
                </div>

                {/* Managed Services */}
                <div
                  onMouseEnter={() => setActiveKey("managed")}
                  onMouseLeave={() => setActiveKey(null)}
                  className={[
                    "absolute bottom-[-10px] md:bottom-[-20px] left-1/2 -translate-x-1/2 w-[170px] h-[170px] md:w-[200px] md:h-[200px] bg-[#FF8A5C]",
                    circleBase,
                    activeKey === "managed" ? circleHover : "",
                    "cursor-pointer",
                  ].join(" ")}
                >
                  <div className={outerText}>
                    MANAGED
                    <br />
                    SERVICES
                  </div>
                </div>

                {/* 中心：Custom Solutions（不动） */}
                <div className="absolute z-30 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[105px] h-[105px] md:w-[125px] md:h-[125px] rounded-full bg-white/55 backdrop-blur-lg ring-1 ring-white/70 shadow-[0_16px_35px_rgba(30,11,68,0.12)] flex items-center justify-center">
                  <div className={centerText}>
                    CUSTOM
                    <br />
                    SOLUTIONS
                  </div>
                </div>
              </div>
            </motion.div>

            {/* 右侧：三张彩色卡片（✅ 现在会真的动） */}
            <motion.div
              className="w-full"
              variants={textVariants}
              initial="hidden"
              animate="visible"
            >
              <motion.div
                className="space-y-6"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={cardsContainer}
              >
                {/* AI Consulting */}
                <motion.div
                  variants={cardItem}
                  onMouseEnter={() => setActiveKey("ai")}
                  onMouseLeave={() => setActiveKey(null)}
                  animate={activeKey === "ai" ? lift : rest}
                  whileHover={lift}
                  transition={{ type: "spring", stiffness: 320, damping: 22 }}
                  className={[
                    "bg-[#fce8ee]",
                    cardBase,
                    activeKey === "ai" ? cardActiveVisual : "",
                    "cursor-pointer",
                  ].join(" ")}
                >
                  <h3 className="text-xl font-bold text-[#8a2f4f] mb-2">
                    AI CONSULTING
                  </h3>
                  <p className="text-purple-900 tracking-wide text-[0.95rem] leading-relaxed text-justify">
                    Our team of AI experts brings industry-leading expertise in
                    machine learning, deep learning, and advanced analytics
                    customised to real-world scenarios.
                    <br />
                    <br />
                    We collaborate closely with clients through the design,
                    development, and deployment of practical AI solutions
                    tailored to their specific industry needs — enabling
                    measurable business outcomes.
                  </p>
                </motion.div>

                {/* IDC Consulting */}
                <motion.div
                  variants={cardItem}
                  onMouseEnter={() => setActiveKey("idc")}
                  onMouseLeave={() => setActiveKey(null)}
                  animate={activeKey === "idc" ? lift : rest}
                  whileHover={lift}
                  transition={{ type: "spring", stiffness: 320, damping: 22 }}
                  className={[
                    "bg-[#f4e8ff]",
                    cardBase,
                    activeKey === "idc" ? cardActiveVisual : "",
                    "cursor-pointer",
                  ].join(" ")}
                >
                  <h3 className="text-xl font-bold text-[#6a2dd9] mb-2">
                    IDC CONSULTING
                  </h3>
                  <ul className="list-disc pl-5 text-purple-900 tracking-wide text-[0.95rem] space-y-1 leading-relaxed">
                    <li>
                      Expert E2E guidance across all facets of DC architectures.
                    </li>
                    <li>
                      Server configuration optimized for specific workload
                      profiles.
                    </li>
                    <li>
                      Network topology design for high availability and low
                      latency.
                    </li>
                    <li>
                      Security consulting focusing on physical and logical
                      protection.
                    </li>
                  </ul>
                </motion.div>

                {/* Managed Services */}
                <motion.div
                  variants={cardItem}
                  onMouseEnter={() => setActiveKey("managed")}
                  onMouseLeave={() => setActiveKey(null)}
                  animate={activeKey === "managed" ? lift : rest}
                  whileHover={lift}
                  transition={{ type: "spring", stiffness: 320, damping: 22 }}
                  className={[
                    "bg-[#ece6ff]",
                    cardBase,
                    activeKey === "managed" ? cardActiveVisual : "",
                    "cursor-pointer",
                  ].join(" ")}
                >
                  <h3 className="text-xl font-bold text-[#3a1f7a] mb-2">
                    MANAGED SERVICES
                  </h3>
                  <ul className="list-disc pl-5 text-purple-900 tracking-wide text-[0.95rem] space-y-1 leading-relaxed">
                    <li>
                      24/7 proactive monitoring, predictive maintenance, and
                      fault detection.
                    </li>
                    <li>SLA-backed uptime and rapid response support.</li>
                    <li>
                      Expert troubleshooting ensuring sustained performance and
                      reliability.
                    </li>
                    <li>
                      Transparent communication ensuring trust and
                      accountability through the service lifecycle.
                    </li>
                  </ul>
                </motion.div>
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <style>
        {`
          @keyframes spinSlow {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .animate-spin-slow {
            animation: spinSlow 18s linear infinite;
          }
        `}
      </style>
    </>
  );
}

